import React      from 'react';
import DatePicker from 'material-ui/DatePicker';
import Utils from "../../Utils/Utility";

export default class DateRangePicker extends React.Component {

  constructor(props) {
    super(props);

      this.state = {
          minFromDate: '',
          maxFromDate: '',
          minToDate: '',
          maxToDate: '',
          fromDate: '',
          toDate: '',
          autoOk: false,
          disableYearSelection: false,
          defaultDateRangeDays: 547,
          showDatePicker: false,
          timeZone: null
      };
  }

    componentWillMount() {

        this.setState({
            timeZone: this.props.timeZone
        });
    }

    componentDidMount() {

        let timeZone = this.state.timeZone;

        // console.log("timeZone:" + timeZone);

        let currentDateTime = Utils.formatDateTimeWithTimeZone(new Date(), timeZone);
        // let maxDateToTimeZone = Utils.formatDateTimeWithTimeZone(new Date(), timeZone);

        let minDate = new Date(currentDateTime);
        let maxDate = new Date(currentDateTime);


        // let defaultFromDateToTimeZone = Utils.formatDateTimeWithTimeZone(new Date(), timeZone);
        // let defaultToDateToTimeZone = Utils.formatDateTimeWithTimeZone(new Date(), timeZone);

        let defaultFromDate = new Date(currentDateTime);
        let defaultToDate = new Date(currentDateTime);


        let allowMinPastYear = this.props.allowMinPastYear ? this.props.allowMinPastYear : 2;

        minDate.setFullYear(minDate.getFullYear() - allowMinPastYear);
        minDate.setHours(0, 0, 0, 0);
        maxDate.setFullYear(maxDate.getFullYear());
        maxDate.setHours(0, 0, 0, 0);

        // startDefaultFromDays = 6 // for a week
        let startDefaultFromDays = this.props.startDefaultFromDays ? this.props.startDefaultFromDays : 6;

        defaultFromDate.setDate(defaultFromDate.getDate() - startDefaultFromDays);
        defaultFromDate.setHours(0, 0, 0, 0);


        defaultToDate.setHours(23, 59, 59, 0);
        this.state = {
            minFromDate: minDate,
            maxFromDate: maxDate,
            minToDate: defaultFromDate,
            maxToDate: maxDate,
            fromDate: defaultFromDate,
            toDate: defaultToDate,
            autoOk: false,
            disableYearSelection: false,
            defaultDateRangeDays: this.props.defaultDateRangeDays,
            showDatePicker: true
        };

    }

  _handleFromDateChange = (event, date) => {

      let timeZone = this.state.timeZone;

      let currentDateTime = Utils.formatDateTimeWithTimeZone(new Date(), timeZone);

      let today = new Date(currentDateTime);
      let toDate       = this.state.toDate;
      let selectedDate = new Date(date);
      let maxDate      = new Date(date);
      let defaultDays = this.state.defaultDateRangeDays;

      maxDate.setDate(maxDate.getDate() + defaultDays);
      maxDate = maxDate>today ? today : maxDate;

      if(toDate>maxDate){
          toDate = maxDate;
      }

      if(toDate< selectedDate){
          toDate = maxDate;
      }

      date.setHours(0, 0, 0, 0);
      toDate.setHours(23, 59, 59, 0);

      this.setState({
          fromDate  : date,
          toDate    : toDate,
          minToDate : date
      });

      this.props.callBackParent(date,toDate)

  };

  _handleToDateChange = (event, date) => {

      // let today    = new Date();
      let fromDate = this.state.fromDate;
      let minDate  = new Date(date);
      let defaultDays = this.state.defaultDateRangeDays;

      minDate.setDate(minDate.getDate() - defaultDays);
      // console.log(minDate);

      if(fromDate<minDate){
          fromDate = minDate;
      }

      date.setHours(23, 59, 59, 0);
      fromDate.setHours(0, 0, 0, 0);

      this.setState({
          toDate    : date,
          fromDate  : fromDate,
          minToDate : fromDate
      });

      this.props.callBackParent(fromDate,date);
  };

  render() {
    return (
        this.state.showDatePicker ? (
          <div className="row">
              <div className="form-group">
                  <label className="control-label col-sm-3 control-label-export" htmlFor="startDate">Start Date:</label>
                  <div className="col-sm-9 ">
                      <i className="fa fa-calendar" aria-hidden="true"></i>
                      <DatePicker
                          hintText             = "From  Date"
                          autoOk               = {this.state.autoOk}
                          minDate              = {this.state.minFromDate}
                          maxDate              = {this.state.maxFromDate}
                          disableYearSelection = {this.state.disableYearSelection}
                          onChange             = {this._handleFromDateChange}
                          value                = {this.state.fromDate}
                          textFieldStyle       ={{width:"100px"}}
                          className            ={'export-date-picker'}
                      />
                  </div>
              </div>
              <div className="form-group">
                  <label className="control-label col-sm-3 control-label-export" htmlFor="endDate">End Date:</label>
                  <div className="col-sm-9">
                      <i className="fa fa-calendar" aria-hidden="true"></i>
                      <DatePicker
                          hintText             = "To  Date"
                          autoOk               = {this.state.autoOk}
                          minDate              = {this.state.minToDate}
                          maxDate              = {this.state.maxToDate}
                          disableYearSelection = {this.state.disableYearSelection}
                          onChange             = {this._handleToDateChange}
                          value                = {this.state.toDate}
                          textFieldStyle       ={{width:"100px"}}
                          className            ={'export-date-picker'}
                      />
                  </div>
              </div>
          </div>
        ) : null
    );
  }
}



// WEBPACK FOOTER //
// src/components/visualization/date-range-picker.js